import React from "react";
import { Link } from "react-router-dom";
import "../css/policyPages.scss";

function CookiePolicy() {
  return (
    <main className="policy-page">
      <header className="policy-hero">
        <nav aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden="true">/</span>
          <span>Cookie Policy</span>
        </nav>
        <p className="policy-kicker">Your browser, your choices</p>
        <h1>Cookie &amp; Local Storage Policy</h1>
        <p className="policy-intro">
          This policy explains how Jskerandco uses cookies and similar browser
          storage technologies. Last updated September 8, 2026.
        </p>
      </header>

      <div className="policy-layout">
        <aside className="policy-summary" aria-label="Policy summary">
          <strong>At a glance</strong>
          <p>
            The current website does not use advertising or analytics cookies.
            It stores your shopping bag and cookie-notice preference locally on
            your device.
          </p>
        </aside>

        <article className="policy-content">
          <section>
            <h2>What these technologies are</h2>
            <p>
              Cookies are small text files a website may save on your device.
              Local storage is a similar browser feature that lets a site keep
              limited information between visits. In this policy, “browser
              storage” covers both cookies and similar technologies.
            </p>
          </section>

          <section>
            <h2>What this site currently stores</h2>
            <div className="storage-table-wrap">
              <table className="storage-table">
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>Purpose</th>
                    <th>Type and duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><code>cartItems</code></td>
                    <td>Keeps the products and options in your shopping bag.</td>
                    <td>First-party local storage; remains until you clear it.</td>
                  </tr>
                  <tr>
                    <td><code>jskerandcoCookieNotice</code></td>
                    <td>Remembers that you closed or acknowledged the notice.</td>
                    <td>First-party local storage; remains until you clear it.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>
              These entries do not contain payment-card data. The current site
              does not place advertising, profiling, or analytics cookies.
            </p>
          </section>

          <section>
            <h2>Why we use necessary storage</h2>
            <p>
              Shopping-bag storage provides a feature you request when adding a
              product, while notice storage prevents the same message appearing
              on every page. Blocking or clearing storage will not stop you
              browsing, but your bag or notice preference may be lost.
            </p>
          </section>

          <section>
            <h2>Third-party services</h2>
            <p>
              This version of the site does not intentionally load advertising
              or analytics services. Hosting and security providers may process
              basic connection information or use strictly necessary technology
              to deliver and protect the site. Their practices depend on the
              provider used when the site is published.
            </p>
          </section>

          <section>
            <h2>Managing browser storage</h2>
            <p>
              You can inspect, block, or delete site data in your browser’s
              privacy settings. Clearing this site’s data removes the saved bag
              and causes the notice to appear again. Browser controls vary by
              device and browser.
            </p>
          </section>

          <section>
            <h2>If our use changes</h2>
            <p>
              We will update this page before introducing non-essential
              analytics, advertising, or profiling technology. Where applicable,
              those technologies will remain off until you make a clear choice,
              and refusing them will be as easy as accepting them.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              Questions about browser storage or privacy can be sent to{" "}
              <a href="mailto:boxes@jskerandco.club">boxes@jskerandco.club</a>.
              You can also review our <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default CookiePolicy;
